import React from 'react';
import APagination from 'antd-mobile/lib/pagination';



export default class Pagination extends APagination {}